import React from 'react';
import Navbar from '../components/public/Navbar';
import Footer from '../components/public/Footer';
import { Outlet, useLocation } from 'react-router-dom';

const LayoutPublic = ({ children }) => {
  const location = useLocation();
  const hidesLegacyHeader = location.pathname === '/' || location.pathname === '/contato';

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {!hidesLegacyHeader && (
        <header className="sticky top-0 z-50 bg-white shadow-sm">
          <Navbar />
        </header>
      )}
      
      <main className="flex-grow">
        {children || <Outlet />}
      </main>
      
      <Footer />
    </div>
  );
};

export default LayoutPublic;
